<header class="absolute inset-x-0 top-0 z-50" [@fadeIn]>
  <nav
    class="flex items-center justify-between p-6 lg:px-8"
    aria-label="Global"
  >
    <div class="flex lg:flex-1">
      <a [routerLink]="['/']" class="-m-1.5 p-1.5" [@fadeIn]>
        <span class="sr-only">Qootk Logo</span>
        <img
          class="h-8 w-auto"
          src="assets/images/logo/qootk.png"
          alt="Qootk Logo"
        />
      </a>
    </div>
    <div class="flex lg:hidden">
      <button
        type="button"
        class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
        (click)="toggleMobileMenu()"
        [@menuIcon]
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="size-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button>
    </div>
    <div class="hidden lg:flex lg:gap-x-12" [@fadeIn]>
      <a
        *ngFor="let item of menuItems"
        [routerLink]="item.link"
        routerLinkActive="text-indigo-600 font-bold"
        [routerLinkActiveOptions]="{ exact: true }"
        class="text-sm/6 font-semibold text-gray-900 hover:text-gray-600 transition-colors"
      >
        {{ item.label }}
      </a>
    </div>
    <div class="hidden lg:flex lg:flex-1 lg:justify-end lg:items-center lg:gap-x-6" [@fadeIn]>
      <button
        (click)="switchLanguage()"
        class="text-sm/6 font-semibold text-gray-900 hover:text-indigo-600 transition-colors flex items-center gap-2"
        aria-label="Switch language"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
        </svg>
        {{ languageLabel }}
      </button>
      <a href="https://pos.qootk.com" class="group inline-flex items-center text-sm/6 font-semibold text-gray-900 hover:text-indigo-600 transition-all duration-300 hover:scale-105">
        {{ "header.login" | translate }}
        <span class="ml-2 transform transition-transform duration-300 group-hover:translate-x-2">&rarr;</span>
      </a>
    </div>
  </nav>
  <!-- Mobile menu, show/hide based on menu open state. -->
  <div
    class="lg:hidden"
    role="dialog"
    aria-modal="true"
    *ngIf="isMobileMenuOpen"
    [@mobileMenu]="{ value: '', params: mobileMenuAnimationParams }"
  >
    <!-- Background backdrop, show/hide based on slide-over state. -->
    <div class="fixed inset-0 z-50"></div>
    <div
      class="fixed inset-y-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      [ngClass]="{'right-0': currentLang === 'en', 'left-0': currentLang === 'ar'}"
    >
      <div class="flex items-center justify-between">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">Qootk Logo</span>
          <img
            class="h-8 w-auto"
            src="assets/images/logo/qootk.png"
            alt="Qootk Logo"
          />
        </a>
        <button
          type="button"
          class="-m-2.5 rounded-md p-2.5 text-gray-700"
          (click)="toggleMobileMenu()"
        >
          <span class="sr-only">Close menu</span>
          <svg
            class="size-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            data-slot="icon"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="mt-6 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10">
          <div class="space-y-2 py-6">
            <a
              *ngFor="let item of menuItems"
              [routerLink]="item.link"
              routerLinkActive="text-indigo-600 font-bold"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="toggleMobileMenu()"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
            >
              {{ item.label }}
            </a>
          </div>
          <div class="py-6">
            <button
              (click)="switchLanguage()"
              class="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50 w-full text-left flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
              </svg>
              {{ languageLabel }}
            </button>
            <a
              href="#"
              class="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
            >
              {{ "header.login" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="absolute inset-x-0 bottom-0 h-px bg-slate-900/5"></div>
</header>
